export const isDevelopment = process.env.NODE_ENV === 'development'



// WEBPACK FOOTER //
// ./src/utilities/dev.js